import * as React from 'react'

export const SvgChatSelected = (props: React.SVGProps<SVGSVGElement>) => (
  <svg data-name="Layer 1" viewBox="0 0 24 24" aria-hidden={true} {...props}>
    <path d="M18.93 8.13H16.1V6.7A2.7 2.7 0 0013.41 4H4.65A2.71 2.71 0 002 6.7v9.74a.44.44 0 00.68.36L7 14.87h.45v.05a4 4 0 004 4h5l4.41 2a.45.45 0 00.67-.41v-9.7a2.71 2.71 0 00-2.6-2.68zm-11.45 2.7V14h-.77l-3.86 1.73v-9a1.81 1.81 0 011.8-1.8h8.76a1.81 1.81 0 011.8 1.8v1.4h-5a2.67 2.67 0 00-2.73 2.7zm3.37 3.64a.94.94 0 01-.9-1 .89.89 0 01.9-.89.9.9 0 01.94.89 1 1 0 01-.94 1zm3.68 0a1 1 0 01-.9-1 .9.9 0 011.8 0 .94.94 0 01-.9 1zm3.69 0a.94.94 0 01-.9-1 .9.9 0 011.79 0 .94.94 0 01-.89 1z" />
  </svg>
)
export default SvgChatSelected
